require('./blocks/page.index/page-index.less');
require('./blocks/page.index/socials-widget.less');

require('./blocks/benefits/benefits');
require('./blocks/benefit.less');
require('./blocks/fullwidth-slider/fullwidth-slider');

/*
require('./blocks/showcase.less');
require('./blocks/topseller.less');
require('./blocks/product/product');
require('./blocks/products-slider/products-slider');
require('./blocks/section-slider/section-slider');
require('./blocks/brands-slider/brands-slider.less');
require('./blocks/brands-slider/slider-resize-controll');
require('./blocks/calendar-item.less');
require('./blocks/tiles/tiles');
require('./blocks/seminar.less');
require('./blocks/news-list/news-list');
require('./blocks/main-block.less');
require('./blocks/news-item/news-item');
require('./blocks/reviews/reviews');
require('./blocks/review.less');
require('./blocks/subscribe-form/subscribe-form');
require('./blocks/seo-text.less');
require('./blocks/soc-marks.less');
require('./blocks/promos/promos.less');
require('./blocks/promos/promos');*/

require('./blocks/index-block-catalog/index-block-catalog.less');
require('./blocks/index-block-action/index-block-action.less');
require('./blocks/index-block-brands/index-block-brands.less');
require('./blocks/index-block-center/index-block-center.less');
require('./blocks/index-block-news/index-block-news.less');
require('./blocks/index-block-reviews/index-block-reviews.less');
require('./blocks/index-block-subscribe-form/index-block-subscribe-form.less');



// WEBPACK FOOTER //
// ./index.js